import { getDisplayType } from '../constants/getDisplayType'

const chartURL = 'https://www.youtube.com/watch?v=GYjv2LFkeaw'
const widgetURL = 'https://www.youtube.com/watch?v=rH_Zqa1sb38'
const commerceURL = 'https://www.youtube.com/watch?v=ktta1HyZeZg'

export const FEATURE_PREVIEW = {
  PowerTable: 'https://youtu.be/j2XNse98tTA',
  chart__pie: chartURL,
  chart__doughnut: chartURL,
  chart__horizontalBar: chartURL,
  chart__bar: chartURL,
  chart__line: chartURL,
  chart__stepLine: chartURL,
  chart__bubble: chartURL,
  chart__scatter: chartURL,
  chart__stacked: chartURL,
  chart__stackSide: chartURL,
  chart__stackLine: chartURL,
  chart: chartURL,
  Pages: 'https://www.youtube.com/watch?v=yepFx5UCa0k',
  Menu: 'https://www.youtube.com/watch?v=wLn6tFs-rVg',
  CustomDrawer: 'https://www.youtube.com/watch?v=JGddXc3KDRQ',
  // CustomModal: 'https://www.youtube.com/watch?v=ERqK8VWUklo',
  OfflineMode: '',
  CoEdit: 'https://www.youtube.com/watch?v=qNHjhnv3GQg&t=1s',
  infoBox: widgetURL,
  Counter: widgetURL,
  Progress: widgetURL,
  FileViewer: widgetURL,
  TreeView: widgetURL,
  PageSearch: widgetURL,
  Badge: widgetURL,
  SmartVLoginForm: widgetURL,
  DateRange: widgetURL,
  Scheduler: widgetURL,
  GoogleMap: widgetURL,
  TablePricing: widgetURL,
  Spreadsheet: widgetURL,
  InteractiveDocument: widgetURL,
  Stripe: widgetURL,
  ACL: '',
  VersionControl: 'https://www.youtube.com/watch?v=NTNoWmGNGfw',
  CustomDomain: 'https://www.youtube.com/watch?v=us4oM9zDFqk',
  Custom404: 'https://www.youtube.com/watch?v=G7sQ7PaMLaw',
  Custom403: 'https://www.youtube.com/watch?v=b2RyBIYrVJw',
  Commerce: commerceURL,
  ECommerceCatalogue_Default: commerceURL,
  ECommerceCatalogue_Narrow: commerceURL,
  ECommerceProduct: commerceURL,
  ECommerceCartIcon: commerceURL,
  PreparedTemplates: '',

  Workflow: '', //+
  Toast: 'https://www.youtube.com/watch?v=uDSoLaxM--g',
  Timer: '', //+
  Translation: '', //+
  CoBrowsing: '',
  PreviewPublish: '',
  CustomDomainPremium: 'https://youtu.be/us4oM9zDFqk',
}

const WEB_LICENSE_DISABLE_SETTINGS = Object.keys(FEATURE_PREVIEW)

export const getFeatureLabel = (feature) =>
  String(getDisplayType(feature))
    .replace(/(chart__(pie|doughnut|horizontalBar|bar|line|bubble|scatter|stacked|stackSide))/gi, 'Chart')
    .replace(/(ECommerceCatalogue_Default|ECommerceCatalogue_Narrow|ECommerceProduct|ECommerceCartIcon)/gi, 'Commerce')
    .replace('ACL', 'Access Control')
    .replace('Custom404', 'Custom 404 page')
    .replace('Custom403', 'Custom 403 page')
    .replace('VersionControl', 'Version Control')
    .replace('CustomDomain', 'Custom Domain')
    .replace('CustomDrawer', 'Custom Drawer')
    .replace('CustomModal', 'Custom Modal')
    .replace('OfflineMode', 'Offline Mode')
    .replace('CoEdit', 'Co-Edit')
    .replace('CoBrowsing', 'Co-Browsing')
    .replace('PreviewPublish', 'Preview/Publish')

export const isAllowFeature = (feature, profile) => {
  if (!profile || profile.allowWeb === undefined) {
    return true
  }
  let allowWeb = profile.allowWeb
  if (!allowWeb) {
    allowWeb =
      _.get(profile, ['license', 'Optimization', 'TitanWeb']) ||
      _.get(profile, ['license', 'Optimization', 'TitanSurvey']) ||
      _.get(profile, ['license', 'Optimization', 'TitanFlow'])
  }
  if (feature == 'CustomDomain') {
    return Boolean(profile.isCustomDomain)
  } else if (allowWeb) {
    return true
  } else if (!allowWeb && profile.allowTitanSign) {
    ///licenseID !== 15
    return !WEB_LICENSE_DISABLE_SETTINGS.includes(feature)
  } else {
    return !WEB_LICENSE_DISABLE_SETTINGS.includes(feature)
  }
}

export const isAllowBotUI = (profile) => {
  if (profile && profile?.isAdmin) {
    return true
  }
  return false
}

export const isAllowFeatureState = (feature, state) => {
  let license = {
    allowWeb:
      state.getIn(['license', 'allowWeb']) ||
      state.getIn(['license', 'Optimization', 'TitanWeb']) ||
      state.getIn(['license', 'Optimization', 'TitanSurvey']) ||
      state.getIn(['license', 'Optimization', 'TitanFlow']),
    allowTitanSign: state.getIn(['license', 'allowTitanSign']),
  }
  return isAllowFeature(feature, license)
}
